'use strict'
import { useEffect, useContext, useState } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
// import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'
import { Link as MuiLink, Grid, FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel, Typography, Tooltip } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
// import Menu from '@mui/material/Menu'
// import MenuItem from '@mui/material/MenuItem'
import ReportIcon from '@mui/icons-material/Report';
// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
// import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'
import MDInput from "components/MDInput";
// import MDDropdown from 'components/MDDropdown'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'

// zerouno
import authService from 'services/auth.service'
import customerService from 'services/customer.service'
import mainService from 'services/order.service'
import enumerationService from 'services/enumeration.service'
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import utils from 'utils/utils.js'
import RabbitContext from 'context/rabbit.js'
import { config } from 'variables/Config.js'
import { DateTime } from "luxon";

export default function OrderTableScadenza() {
  const location = useLocation()
  const [objId, setObjId] = useState(0)
  const [objects, setObjects] = useState([])
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({
    provincia: "",
    showOnlyCampania: false,
    consegna: null
  });

  const [showSnackbar, setShowSnackbar] = useState({
    sh: false,
    msg: '',
    color: 'success'
  })
  const [openConfirm, setOpenConfirm] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [editingOrder, setEditingOrder] = useState(null)
  const {
    data: enums,
    isLoading: loadEnum,
    error: errEnums
  } = enumerationService.findByType('orderState')
  const { rabbit } = useContext(RabbitContext)
  const sales = useLocation().pathname.includes('sales')
  const {
    data: consegne,
    isLoading: loadConsegne,
    error: errConsegne,
  } = enumerationService.findByType("consegna");

  useEffect(() => {
    fetchObjects()
  }, [sales, location])
  
  useEffect(() => {
    // Apply filters whenever objects change
    if (objects.length > 0) {
      applyFilters(filters);
    }
  }, [objects]);

  const fetchObjects = () => {
    mainService
      .findDelivered(rabbit.companyId)
      .then(response => {
        const orders = response.data.filter(s => rabbit.black ? s.code === '50' : s.code !== "50")
        // Filtra e prepara gli ordini scaduti con i giorni di ritardo
        const scaduti = orders
          .map((order) => {
            const inizio = order.dateBegin ? DateTime.fromISO(order.dateBegin).toJSDate() : null;
            const giorni = order.quantity;
            const scadenza = inizio
              ? DateTime.fromISO(order.dateBegin).plus({ days: order.quantity })
              : null;

            if (inizio && giorni && scadenza && scadenza.diffNow().as("days") < 3) {
              return {
                order,
                scadenza,
                giorniRitardo: (-scadenza.diffNow().as("days")).toFixed(0)
              };
            }
            return null;
          })
          .filter(item => item !== null);
        // Ordina per giorni di ritardo (dal più grande al più piccolo)
        scaduti.sort((a, b) => parseFloat(b.giorniRitardo) - parseFloat(a.giorniRitardo));
        setObjects(scaduti)
        setFiltered(scaduti)
      })
      .catch(error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      })
  }

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    mainService.remove(objId).then(
      response => {
        setShowSnackbar({
          sh: true,
          msg: 'operazione effettuata con successo',
          color: 'success'
        })
        fetchObjects()
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  const handleOpenEditDialog = (item) => {
    // Passa l'ordine effettivo, non l'oggetto wrapper
    setEditingOrder(item.order)
    setOpenEditDialog(true)
  }

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false)
    setEditingOrder(null)
  }

  // Funzione di validazione come in OrderForm.js
  const validateOrder = (order) => {
    // stato aperto 1 data inizio = null
    // stato spedito 2 data inizio = null
    // stato consegnato 3 data inizio !=null
    // stato chiuso 4 data inizio !=null
    // stato annullato 5 fai che cazzo vuoi
    const s = order.stateId;
    const d = order.dateBegin;
    const r = order.dateReturn;
    
    if ((s === '3' || s === '4' || s === 3 || s === 4) && !d) {
      setShowSnackbar({
        sh: true,
        msg: "inserire la data di inizio",
        color: "error",
      });
      return false;
    }
    
    if (!order.sale && (s === '4' || s === 4) && !r) {
      setShowSnackbar({
        sh: true,
        msg: "inserire la data di rientro",
        color: "error",
      });
      return false;
    }
    
    return true;
  };

  const handleSaveEdit = () => {
    if (!editingOrder) return

    // Creiamo una copia dell'ordine per applicare i controlli
    const orderToSave = { ...editingOrder }
    
    // Controlli come in OrderForm.js
    const s = orderToSave.stateId
    const d = orderToSave.dateBegin
    const r = orderToSave.dateReturn
    
    // Se lo stato è 1 o 2 (probabilmente in attesa o in lavorazione) e c'è una data di inizio, la impostiamo a null
    if ((s === '1' || s === '2' || s === 1 || s === 2) && (d || d === '')) {
      orderToSave.dateBegin = null
    }
    
    // Se lo stato non è 4 (probabilmente completato) e c'è una data di ritorno, la impostiamo a null
    if ((s !== '4' && s !== 4) && (r || r === '')) {
      orderToSave.dateReturn = null
    }
    
    // Validazione dell'ordine prima di salvare
    if (!validateOrder(orderToSave)) {
      return;
    }

    mainService.update(orderToSave.id, orderToSave).then(
      response => {
        setShowSnackbar({
          sh: true,
          msg: 'Ordine aggiornato con successo',
          color: 'success'
        })
        handleCloseEditDialog()
        fetchObjects()
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'Errore durante l\'aggiornamento dell\'ordine',
          color: 'error'
        })
      }
    )
  }

  const handleFilterChange = (filterName, value) => {
    const newFilters = { ...filters, [filterName]: value };
    setFilters(newFilters);
    applyFilters(newFilters);
  };

  const handleProvincia = (value) => {
    handleFilterChange('provincia', value);
  };

  const handleCampaniaToggle = (event) => {
    const isChecked = event.target.checked;
    handleFilterChange('showOnlyCampania', isChecked);
  };

  const handleConsegna = (value) => {
    handleFilterChange('consegna', value);
  };

  const applyFilters = (currentFilters = filters) => {
    let filteredResults = [...objects];
    
    // Apply provincia filter if provided
    if (currentFilters.provincia !== "") {
      filteredResults = filteredResults.filter(s => s.order.prov.toLowerCase() === currentFilters.provincia.toLowerCase());
    }
    
    // Apply consegna filter if provided
    if (currentFilters.consegna !== null) {
      filteredResults = filteredResults.filter(s => s.order.consegnaId === currentFilters.consegna.id);
    }
    
    const campaniaProvinces = ['na', 'ce', 'av', 'bn', 'sa'];
    filteredResults = filteredResults.filter(s => currentFilters.showOnlyCampania ? 
      campaniaProvinces.includes(s.order.prov.toLowerCase()) : !campaniaProvinces.includes(s.order.prov.toLowerCase())
    );
    
    setFiltered(filteredResults);
  };

  const columns = [
    {
      Header: 'azioni',
      sortable: false,
      filterable: false,
      width: 100,
      accessor: row => (
        <>
          <MDButton
            color='info'
            size='small'
            iconOnly
            component={Link}
            to={`/customers/${row.order.customer.id}/orders/${row.order.id}`}
            sx={{ mr: 1 }}
          >
            <Icon>edit</Icon>
          </MDButton>
          <MDButton
            color='info'
            size='small'
            iconOnly
            onClick={() => handleOpenEditDialog(row)}
            sx={{ mr: 1 }}
          >
            <Icon>rate_review</Icon>
          </MDButton>
          {row.order.customer.mobile && (
            <MDButton
              color="success"
              size="small"
              iconOnly
              component="a"
              href={`https://wa.me/${row.order.customer.mobile}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ mr: 1 }}
            >
              <Icon>phone</Icon>
            </MDButton>)}
            {row.order.notes && (
              <Tooltip title={row.order.notes}>
                <ReportIcon color='warning' fontSize="medium"/>
              </Tooltip>)}
        </>
      )
    },
    {
      Header: 'cliente',
      accessor: row =>
        row.order.customer.surname.toUpperCase() +
        ' ' +
        row.order.customer.name.toUpperCase()
    },
    {
      Header: "cell",
      accessor: (row) =>
        row.order.customer.mobile,
    },
    {
      Header: 'data',
      accessor: d => {
        return utils.formatDate(d.order.dateOrder, 'dd/MM/yyyy')
      }
    },
    {
      Header: 'consegna',
      accessor: d => {
        return d.order.dateBegin ? utils.formatDate(d.order.dateBegin, 'dd/MM/yyyy') : '-'
      }
    },
    {
      Header: 'prov.',
      accessor: row => row.order.prov.toUpperCase()
    },
    {
      Header: 'numero',
      accessor: d => {
        return d.order.number + ' ' + d.order.code + (d.order.extension ? ' [ext]' : '') + (d.order.substitution ? ' [sost]' : '')
      }
    },
    {
      Header: "scadenza",
      accessor: (d) => {
        if (!d.order.dateBegin) return "-";

        const endDate = DateTime.fromISO(d.order.dateBegin).plus({
          days: d.order.quantity - 1,
        });

        const formattedDate = endDate.toFormat("dd/MM/yyyy");
        const isExpired = endDate < DateTime.now();

        return {
          date: formattedDate,
          isExpired: isExpired,
        };
      },
      Cell: ({ value }) => (
        <span style={{ color: value.isExpired ? "red" : "inherit" }}>
          {value.date}
        </span>
      ),
    },
    {
      Header: "ritardo",
      accessor: (d) => {
        return d.giorniRitardo
      }
    },
    {
      Header: 'prenotato',
      accessor: d => {
        return d.order.datePrenotazioneRitiro ? utils.formatDate(d.order.datePrenotazioneRitiro, 'dd/MM/yyyy') : '-'
      }
    },
    {
      Header: 'prezzo',
      accessor: d => {
        return d.order.price
      },
      Cell: ({ value, row }) => utils.formatFloat(value.toFixed(2))
    },
    {
      Header: 'totale',
      accessor: d => {
        return d.order.totalAmount
      },
      Cell: ({ value, row }) => utils.formatFloat(value.toFixed(2))
    },
    {
      Header: 'da pagare',
      accessor: d => {
        return d.order.toPay
      },
      Cell: ({ value, row }) => utils.formatFloat(value.toFixed(2))
    },
    {
      Header: "dispositivo",
      accessor: d => {
        return d.order.product ? d.order.product.productModel.name : "---"
      },
    },
    {
      Header: 'seriale',
      accessor: d => {
        return d.order.product
          ? d.order.product.serial +
          ' | ' +
          d.order.product.batch +
          ' [' +
          (d.order.companyId === 1 ? 'T' : 'B') +
          ']'
          : '---'
      }
    },
    ...(authService.isAdmin()
      ? [
        {
          Header: 'agente',
          accessor: d => {
            return d.order.agent ? d.order.agent.surname + ' ' + d.order.agent.name : ''
          }
        },
        {
          Header: 'tecnico',
          accessor: d => {
            return d.order.technician ? d.order.technician.surname + ' ' + d.order.technician.name : ''
          }
        },
        {
          Header: 'utente',
          accessor: d => {
            return d.order.user ? d.order.user.username : ''
          }
        }
      ]
      : []),
      {
        Header: "telefono",
        accessor: (row) =>
          row.order.customer.phone,
      },
      {
        Header: 'ddt',
        accessor: (d) => {
          return d.order.ddtNumber ?? "";
        },
      },
  ]



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <ZUTitleForm
            bgColor='info'
            title='Ordini in scadenza'
            icon='list_alt'
          />
          <MDBox p={3} lineHeight={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" spacing={2}>
                {authService.isAdmin() && (
                  <MDButton
                    variant="gradient"
                    color="success"
                    component={MuiLink}
                    href={`${config.SERVER_URL}/orders/download/excel/scadenza?companyId=${rabbit.companyId}`}
                    target="_blank"
                  >
                    <Icon sx={{ fontWeight: "bold" }}>file_download</Icon>
                    &nbsp;esporta in excel
                  </MDButton>
                )}
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <FormControlLabel
                  control={
                    <Switch
                      checked={filters.showOnlyCampania}
                      onChange={handleCampaniaToggle}
                      color="info"
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {filters.showOnlyCampania ? "Campania" : "Italia"}
                    </Typography>
                  }
                />
                <MDInput
                  label="Provincia"
                  value={filters.provincia}
                  onChange={(event) => {
                    handleProvincia(event.target.value);
                  }}
                />
                <Autocomplete
                  disablePortal
                  id="consegna"
                  value={filters.consegna || null}
                  options={consegne || []}
                  sx={{ width: 150 }}
                  renderInput={(params) => (
                    <MDInput {...params} label="consegna" />
                  )}
                  onChange={(event, value) => {
                    handleConsegna(value);
                  }}
                  getOptionLabel={(option) => option.description}
                />
              </Stack>
            </Stack>
          </MDBox>
          <DataTable 
            table={{ columns: columns, rows: filtered }} 
            canSearch 
            pagination={{ 
              variant: "gradient", 
              color: "info",
              currentPage: currentPage,
              onPageChange: (newPage) => setCurrentPage(newPage)
            }}
          />
        </Card>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>
            Conferma
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />

      {/* Quick Edit Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Modifica rapida ordine</DialogTitle>
        <DialogContent>
          {editingOrder && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth required>
                  <InputLabel>Stato</InputLabel>
                  <Select
                    label="Stato"
                    value={editingOrder.stateId}
                    onChange={(e) => setEditingOrder({...editingOrder, stateId: e.target.value})}
                  >
                    {enums &&
                      enums.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.description}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <MDInput
                  fullWidth
                  type="date"
                  label="Data consegna"
                  value={editingOrder.dateBegin ? DateTime.fromISO(editingOrder.dateBegin).toISODate() : ''}
                  onChange={(e) => setEditingOrder({...editingOrder, dateBegin: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <MDInput
                  fullWidth
                  type="date"
                  label="Data rientro"
                  disabled={!authService.isAdmin()}
                  value={editingOrder.dateReturn ? DateTime.fromISO(editingOrder.dateReturn).toISODate() : ''}
                  onChange={(e) => setEditingOrder({...editingOrder, dateReturn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  fullWidth
                  type="text"
                  label="Note"
                  value={editingOrder.notes || ''}
                  onChange={(e) => setEditingOrder({...editingOrder, notes: e.target.value})}
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleCloseEditDialog}>Annulla</MDButton>
          <MDButton onClick={handleSaveEdit} color="info">
            Salva
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  )
}
